import { z } from 'zod';

import { defineService } from '@@api/lib/defineService';
import { UserPresence, UserPresenceUser } from '@@api/services/userPresence/schemas';
import config from '@@config';

export const userPresenceService = defineService(
    (defineEndpoint) => ({
        userPresence: {
            getAll: defineEndpoint({
                method: 'GET',
                path: '/user-presences/:id',
                pathParams: z.object({
                    id: z.string(),
                }),
                responses: {
                    200: UserPresence,
                },
            }),
            patchAll: defineEndpoint({
                method: 'PATCH',
                path: '/user-presences/:id',
                pathParams: z.object({
                    id: z.string(),
                }),
                body: z.object({
                    users: z.record(
                        z.string(),
                        UserPresenceUser.pick({ attributes: true }).nullable(),
                    ),
                }),
                responses: {
                    200: UserPresence,
                },
            }),
        },
    }),
    {
        baseUrl: config.apiEnvVars.userPresencesUrl,
    },
);
